import {
  Col,
  Row,
  message,
  Popconfirm,
  Space,
  Typography,
  Form,
  Button,
  Input,
  Divider,
} from "antd"
import React, { useState } from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { MergeCellsOutlined } from "@ant-design/icons"
import StandartTable from "../../../components/Elements/StandartTable"
import { useCollection } from "../../../hooks/useCollection"
import { db } from "../../../firebase/config"
import { addDoc, collection, deleteDoc, doc } from "firebase/firestore"
import RichTextEditor from "../../../components/Email/RichTextEditor"

const { Link } = Typography

export default function MaterialSuppliers() {
  const { data, loading } = useCollection("materialSuppliers")
  const [emailForm, setEmailForm] = useState(null)

  const [form] = Form.useForm()

  //Delete material
  const deleteSupplier = async (e, docid) => {
    e.preventDefault()
    const ref = doc(db, "materialSuppliers", docid)
    try {
      await deleteDoc(ref).then(() => {
        message.success("Deleted!")
      })
    } catch (err) {
      message.success(err.message)
    }
  }

  const onFinish = (values) => {
    console.log("Success:", values)
    createSupplier(values)
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  //default columns for table
  const supplierColumns = [
    {
      title: "Supplier Name",
      dataIndex: "supplierName",
      align: "center",
    },

    {
      title: "Supplier Contact",
      dataIndex: "supplierContact",
      align: "center",
    },
    {
      title: "Comment",
      dataIndex: "comment",
      align: "center",
    },

    {
      title: "Action",
      align: "center",
      render: (value) => (
        <>
          <Space split>
            <Popconfirm
              title="Are you sure？"
              placement="left"
              onConfirm={(event) => deleteSupplier(event, value.id)}
              okText="Yes"
              cancelText="No">
              <Link style={{ color: "red" }}>delete</Link>
            </Popconfirm>
          </Space>
        </>
      ),
    },
  ]

  const createSupplier = async (data) => {
    const ref = collection(db, "materialSuppliers")

    try {
      await addDoc(ref, data)
        .then(() => {
          message.success(`Success! Supplier has been created.`)
        })
        .then(() => {
          form.resetFields() // Reset form fields after the data is successfully added
        })
    } catch (err) {
      message.error(err.message)
    }
  }

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader icon={<MergeCellsOutlined />} text="Raw Material Suppliers" />
        </Col>
        <Col span={16}>
          <StandartTable loading={loading} data={data} columns={supplierColumns} />
        </Col>
        <Col span={8}>
          <Divider>Create Supplier</Divider>
          <Form
            form={form}
            name="basic"
            style={{ width: "100%", padding: 25 }}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off">
            <Form.Item
              label="Supplier Name"
              name="supplierName"
              rules={[
                {
                  required: true,
                  message: "Please input your username!",
                },
              ]}>
              <Input placeholder="Supplier name" />
            </Form.Item>
            <Form.Item
              label="Supplier Contact"
              name="supplierContact"
              rules={[
                {
                  required: true,
                  message: "Please input your username!",
                },
              ]}>
              <Input placeholder="Supplier contact email" />
            </Form.Item>
            <Form.Item name="comment" label="Comment">
              <Input.TextArea name="comment" rows={2} placeholder="Supplier comment" />
            </Form.Item>
            <Form.Item name="emailTemplate" label="Email Template">
              <RichTextEditor form={form} setEmailForm={setEmailForm} />
            </Form.Item>

            <Form.Item>
              <Button block type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <button onClick={() => console.log(emailForm)}>log</button>
    </div>
  )
}
